import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import { unregister } from './registerServiceWorker';

import FullStory from "react-fullstory";
import { Userpilot } from "userpilot";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

import {
    isProduction,
    isStaging,
    isQA,
    isLeading,
    isTrailing,
    getConfig,
    isLocalHost
} from "./lib/utils";

import "@fortawesome/fontawesome-pro/css/all.css";

//import 'bootstrap/dist/css/bootstrap.css'
import "./css/index.scss";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

let clientSideID = "5fadac306caa1f0a1a58ef95";
if (isStaging()) {
    clientSideID = "5fadac55bb17700a04240e69";
}
if (isQA()) {
    clientSideID = "5fadac11c1f7360a5eb20d68";
}
if (isLeading()) {
    clientSideID = "5fbd944e943b4e09a2297be4";
}
if (isTrailing()) {
    clientSideID = "5fbd9467b051d70981ba5d4e";
}
if (isProduction()) {
    clientSideID = "5fadac11c1f7360a5eb20d69";
}

//if (isLocalHost() !== true && isProduction()) {
//    ReactDOM.render(<FullStory org={getConfig().fullstoryId} />, document.getElementById("fullstory-node"));
//}

(async () => {
    const LDProvider = await asyncWithLDProvider({
        clientSideID: clientSideID,
        user: {
            key: "anon",
            name: "Anonymous"
        }
    });

    Userpilot.initialize("40fr55f4");

    ReactDOM.render(
        <LDProvider>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </Provider>
        </LDProvider>,
        document.getElementById('root'));
})();

unregister();
